export default "__VITE_ASSET__10ab15d1__"